import React, { useState, useEffect, FormEvent } from 'react';
import DeviceSelectionScreen from './DeviceSelectionScreen/DeviceSelectionScreen';
import MediaErrorSnackbar from './MediaErrorSnackbar/MediaErrorSnackbar';
import useVideoContext from '../hooks/useVideoContext/useVideoContext';

export enum Steps {
  deviceSelectionStep,
}

export default function PreJoinScreens({name, roomName, displayName, onCancel}) {
  const { getAudioAndVideoTracks } = useVideoContext();
  const [mediaError, setMediaError] = useState<Error>();

  useEffect(() => {
    if (!mediaError) {
      getAudioAndVideoTracks().catch(error => {
        setMediaError(error);
      });
    }
  }, [getAudioAndVideoTracks, mediaError]);

  return (
    <div>
      <MediaErrorSnackbar error={mediaError} />
        <DeviceSelectionScreen name={name} roomName={roomName} displayName={displayName} onCancel={onCancel}/>
    </div>
  );
}
